/**
 *
 * Asynchronously loads the component for VideoWorkOut
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
